document.addEventListener('DOMContentLoaded', function () {
    let splideCheck = document.getElementsByClassName("splide").length;
    if (splideCheck) {
        console.log('Splide active');
        new Splide( '.splide', {
            type   : 'loop',
            perPage: 1,
            autoplay : true,
            interval : 5000,
            pauseOnHover : true,
            resetProgress : false,
            speed: 2500,
            arrows: false,
            pagination: true
        }).mount();
    } else {
        console.log('Splide inactive');
    }
});